export default __webpack_public_path__ + "static/media/green-lightning.c20f110b.svg";